<template>
  <div class="shinsotsu-saiyou">
    <div class="s-title">
      <p class="s-title_p">
        <span>新</span>
        <span>卒</span>
        <span>採</span>
        <span>用</span>
      </p>
    </div>
    <div class="s-top">
      <h1 class="s-top_title">ファミリー庭園とは？</h1>
      <p class="s-top_p">
        当社は、家の外まわり（外構・お庭など）をデザイン・設計・施工する会社です。
        <br />ホームページの施工実績数やお客様の声などを見ていただければ分かるかと思われますが、弊社は日本一の規模を誇る、業界のリーディングカンパニーです。
      </p>
      <p class="s-top_ledingCompany">Leading Company</p>
      <img src="/newgrad/leading-company.png" />
    </div>
    <h1 class="s-top_title">私たちの仕事</h1>
    <div class="s-box">
      <img src="/newgrad/shinsotsu1.png" class="s-box-img" />
      <div class="s-box-setsumei">
        <h2 class="s-box-setsumei_title">
          外構が大切な住まいの
          <br />第一印象を決める。
        </h2>
        <div class="s-box-setsumei_p">
          <p>
            「イケメンなのにファッションセンスがイマイチ」とか「メイクが時代遅れで損してる人」っていますよね？
            それは住まいでも同じこと。待望のマイホームを建てることになって間取りやリビングのテイスト・
            家族の希望など様々なイメージを施工業者さんに伝えながらどんどん「夢を形に」していきます。
          </p>
          <p>
            しかし、意外とイメージしにくいのが「外構」と呼ばれる生け垣や庭・カーポート
            といった建物以外の家を構成する要素です。建物が人の顔とするなら外構はその人が着ている服。
            顔以上にその人の趣味やセンス、時には人柄までも表現するように、外構はその家に住む人のイメージ、
            そして魅力的な外構を持つ家が建ち並ぶ姿はその街のイメージすら形づくると私たちは考えます。
          </p>
          <p>
            私たちファミリー庭園は創業以来、数々の住まいの外構を手がけその豊富な施工実績に基づき、
            お客様の描いたイメージをプロの視点で魅力的な外構を実現することにより、住む人の快適な暮らしのお手伝いをしています。
          </p>
        </div>
      </div>
    </div>

    <h1 class="s-top_title">求めている人材</h1>
    <div class="s-box2">
      <p>
        求めている人材は「真面目な方」です。
        <br />真面目に弊社のノウハウを身につけて頂ければ、
        <br />必ず一人前になることができます。
        <br />
      </p>
      <p>
        成果があればそれにみあったステージを用意して
        <br />あなたのやる気に応える会社です。
        <br />真面目で、自分自身の成長を楽しめる方の応募をお待ちしています！
      </p>
      <img src="/newgrad/shinsotsu2.png" class="s-box2-img" />
    </div>

    <h1 class="s-top_title">会社紹介動画</h1>
    <iframe
      class="youtube"
      src="https://www.youtube.com/embed/i3lkS_qyZzI"
      frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>

    <h1 class="s-top_title">採用フロー</h1>
    <div class="s-saiyou">
      <div class="s-saiyou-flow">
        <p class="s-saiyou-flow_p">会社説明会</p>
        <p class="pc">⇒</p>
        <p class="smaho">⇓</p>
        <p class="s-saiyou-flow_p">面接(複数回)・適正テスト</p>
        <p class="pc">⇒</p>
        <p class="smaho">⇓</p>
        <p class="s-saiyou-flow_p">内定</p>
        <p class="pc">⇒</p>
        <p class="smaho">⇓</p>
        <p class="s-saiyou-flow_p">入社（4/1）</p>
      </div>

      <div class="corona">
        <h2 class="corona-title red">内定者対象 コロナ学費支援有ります</h2>
        <div class="corona-text">
          <h3 class="corona-text--h3">
            無利子融資：
            <span class="red">最大50万円</span>
          </h3>
          <h3 class="corona-text--h3">内10万円は会社支援致します！</h3>
          <p class="corona-text--p">
            返済方法については相談可。最大2年
            <br />※10万円支援は支援策とセットになります。
            <br />※「みどりの就活」などの就活マッチングサイトを経由しエントリーした方は対象外になります。
          </p>
        </div>
      </div>

      <div class="s-saiyou_setsumeikai">
        <h1 class="s-top_title">会社説明会</h1>
        <p>
          下記のお問い合わせフォームもしくはお電話にて、事前予約をお願いします。
          <br />その際に時間などを調整いたします。
          <br />また説明会後、すぐ1次面接させて頂くことも可能ですので、
          <br />ご希望の方は履歴書をご持参ください。
        </p>
        <p class="red">WEB説明会・面接も随時開催中</p>
      </div>
    </div>

    <div class="s-entry">
      <div class="s-entry-way">
        <p class="s-entry-way_tel">
          お電話でのご予約はこちらから
          <br />
          <span class="s-entry-way_tel-number">
            <font-awesome-icon icon="phone-alt" class="phone-alt" />06-6777-9544
          </span>
          <br />
          <span>
            ネットでのご予約、お申し込みは
            <br />下記メールフォームより受け付けております
          </span>
        </p>
      </div>

      <FormStep v-bind:step="1"></FormStep>

      <div class="errorMessage" v-show="ErrorTop">
        <p>
          入力に誤りがあるか、未入力になっています。
          <br />再度ご確認のうえ、修正してください。
        </p>
      </div>
      <div id="a"></div>

      <div class="s-entry-form">
        <FormWaku v-bind:hissu="true" ref="job">
          <template v-slot:title>職種選択</template>
          <label class="s-entry-form_item-a-item">
            <input type="radio" name="job" value="プランナー（総合職）" v-model="form_data.job" checked="checked" />プランナー（総合職）
          </label>
          <br />
          <label class="s-entry-form_item-a-item">
            <input type="radio" name="job" value="事務職（一般職）" v-model="form_data.job" />事務職（一般職）
          </label>
          <p v-if="new Date().getMonth()+1==3" class="error">
            ※{{new Date().getFullYear()}}年度新卒（事務職）エントリー受付は終了しました
          </p>
          <template v-slot:error>
            <p class="error" v-show="check.job">
              <font-awesome-icon icon="exclamation-triangle" />選択してください
            </p>
          </template>
        </FormWaku>

        <FormWaku v-bind:hissu="true" ref="kinmuchi">
          <template v-slot:title>
            希望勤務地
            <br />
            <span class="font-red">※複数選択可</span>
          </template>
          <div class="s-entry-form_item-a flex">
            <label class="s-entry-form_item-a-item flex-item">
              <input type="checkbox" value="大阪府" v-model="form_data.kinmuchi" />大阪府
            </label>
            <label class="s-entry-form_item-a-item flex-item">
              <input type="checkbox" value="奈良県" v-model="form_data.kinmuchi" />奈良県
            </label>
            <label class="s-entry-form_item-a-item flex-item">
              <input type="checkbox" value="兵庫県" v-model="form_data.kinmuchi" />兵庫県
            </label>
            <label class="s-entry-form_item-a-item flex-item">
              <input type="checkbox" value="京都府" v-model="form_data.kinmuchi" />京都府
            </label>
            <label class="s-entry-form_item-a-item flex-item">
              <input type="checkbox" value="滋賀県" v-model="form_data.kinmuchi" />滋賀県
            </label>
            <label class="s-entry-form_item-a-item flex-item">
              <input type="checkbox" value="和歌山県" v-model="form_data.kinmuchi" />和歌山県
            </label>
            <label class="s-entry-form_item-a-item flex-item">
              <input type="checkbox" value="神奈川県" v-model="form_data.kinmuchi" />神奈川県
            </label>
            <label class="s-entry-form_item-a-item flex-item">
              <input type="checkbox" value="埼玉県" v-model="form_data.kinmuchi" />埼玉県
            </label>
            <label class="s-entry-form_item-a-item flex-item">
              <input type="checkbox" value="三重県" v-model="form_data.kinmuchi" />三重県
            </label>
            <label class="s-entry-form_item-a-item flex-item">
              <input type="checkbox" value="愛知県(名古屋)" v-model="form_data.kinmuchi" />愛知県(名古屋)
            </label>
            <label class="s-entry-form_item-a-item flex-item">
              <input type="checkbox" value="福岡県" v-model="form_data.kinmuchi" />福岡県
            </label>
            <label class="s-entry-form_item-a-item flex-item">
              <input type="checkbox" value="どこでもOK" v-model="form_data.kinmuchi" />どこでもOK
            </label>
          </div>
          <template v-slot:error>
            <p class="error" v-show="check.kinmuchi">
              <font-awesome-icon icon="exclamation-triangle" />選択してください
            </p>
          </template>
        </FormWaku>

        <FormWaku v-bind:hissu="true" ref="namae">
          <template v-slot:title>お名前</template>
          <label class="s-entry-form_item-a-item">
            <input type="text" class="name" placeholder="例：山田 太郎" v-model="form_data.name.kanji" />
          </label>
          <template v-slot:error>
            <p class="error" v-show="check.namae">
              <font-awesome-icon icon="exclamation-triangle" />入力してください
            </p>
          </template>
        </FormWaku>

        <FormWaku v-bind:hissu="true" ref="furigana">
          <template v-slot:title>ふりがな</template>
          <label class="s-entry-form_item-a-item">
            <input
              type="text"
              class="name"
              placeholder="例：やまだ たろう"
              v-model="form_data.name.furigana"
            />
          </label>
          <template v-slot:error>
            <p class="error" v-show="check.furigana">
              <font-awesome-icon icon="exclamation-triangle" />入力してください
            </p>
          </template>
        </FormWaku>

        <FormWaku v-bind:hissu="true" ref="seibetsu">
          <template v-slot:title>性別</template>
          <label class="s-entry-form_item-a-item">
            <input type="radio" name="seibetsu" value="男性" v-model="form_data.seibetsu" />男性
          </label>
          <label class="s-entry-form_item-a-item">
            <input type="radio" name="seibetsu" value="女性" v-model="form_data.seibetsu" />女性
          </label>
          <template v-slot:error>
            <p class="error" v-show="check.seibetsu">
              <font-awesome-icon icon="exclamation-triangle" />選択してください
            </p>
          </template>
        </FormWaku>

        <FormWaku v-bind:hissu="true" ref="sotsugyou">
          <template v-slot:title>卒業(予定)年月</template>
          <label class="s-entry-form_item-a-item">
            <select name="year" id="select_year" class="nengetsu" v-model="form_data.graduate.year">
              <option value>--</option>
              <option v-bind:value="i" v-for="(i,index) in year" v-bind:key="index">{{i}}</option>
            </select>&nbsp;年
          </label>
          <label class="s-entry-form_item-a-item">
            <select
              name="month"
              id="select_month"
              class="nengetsu"
              v-model="form_data.graduate.month"
            >
              <option value>--</option>
              <option v-bind:value="i" v-for="(i,index) in 12" v-bind:key="index">{{i}}</option>
            </select>&nbsp;月
          </label>
          <template v-slot:error>
            <p class="error" v-show="check.sotsugyou">
              <font-awesome-icon icon="exclamation-triangle" />選択してください
            </p>
          </template>
        </FormWaku>

        <FormWaku v-bind:hissu="true" ref="university">
          <template v-slot:title>
            所属している
            <br />学校名
          </template>
          <label class="s-entry-form_item-a-item">
            <input type="text" class="name" v-model="form_data.university" />
          </label>
          <template v-slot:error>
            <p class="error" v-show="check.university">
              <font-awesome-icon icon="exclamation-triangle" />入力してください
            </p>
          </template>
        </FormWaku>

        <FormWaku>
          <template v-slot:title>住所</template>
          <label class="s-entry-form_item-a-item">
            〒&nbsp;
            <input
              type="tel"
              v-model="form_data.juusyo.yuubin_num"
              class="yubin-num"
              placeholder="000-0000"
            />
            <button class="address-search" v-on:click="addressSearch">住所検索</button>
          </label>

          <br />
          <label class="s-entry-form_item-a-item">
            <input type="text" class="addless" v-model="form_data.juusyo.address" />
            <small style="font-size: 75%;">※会社案内のパンフレットの郵送をご希望の方は、住所入力をお願いいたします。</small>
          </label>
        </FormWaku>

        <FormWaku v-bind:hissu="true" ref="tel">
          <template v-slot:title>電話番号</template>
          <label class="s-entry-form_item-a-item">
            <input type="tel" class="name" placeholder="例：080-0000-0000" v-model="form_data.tel" />
          </label>
          <template v-slot:error>
            <p class="error" v-show="check.tel">
              <font-awesome-icon icon="exclamation-triangle" />
              {{check.tel}}
            </p>
          </template>
        </FormWaku>

        <FormWaku v-bind:hissu="true" ref="mail">
          <template v-slot:title>メールアドレス</template>
          <label class="s-entry-form_item-a-item">
            <input
              type="text"
              class="email"
              placeholder="例：example@example.com"
              v-model="form_data.mail"
            />
          </label>
          <template v-slot:error>
            <p class="error" v-show="check.mail">
              <font-awesome-icon icon="exclamation-triangle" />
              {{check.mail}}
            </p>
          </template>
        </FormWaku>

        <FormWaku>
          <template v-slot:title>
            ご質問
            <br />ご要望など
          </template>
          <label class="s-entry-form_item-a-item">
            <textarea class="textarea-q" v-model="form_data.question" />
          </label>
          <template v-slot:error>
            <p class="error"></p>
          </template>
        </FormWaku>
      </div>
      <div v-on:click="form_check()">
        <FormBtn>
          <template>入力内容の確認画面へ</template>
        </FormBtn>
      </div>
    </div>
  </div>
</template>

<script>
import FormWaku from "@/components/form_waku.vue";
import FormStep from "@/components/form_step.vue";
import FormBtn from "@/components/form_btn.vue";
export default {
  name: "shinsots-saiyou",
  metaInfo: {
    title: "新卒採用",
    meta: [
      {
        name: "description",
        content: ""
      }
    ]
  },
  components: {
    FormWaku,
    FormStep,
    FormBtn
  },
  props: { form_data: Object, click: Boolean },
  data() {
    return {
      year: [],
      month: "",
      pref: "",
      city: "",
      town: ""
    };
  },
  methods: {
    //フォームチェック
    form_check() {
      this.$emit("click_kakunin");
      var self = this;
      var errorScroll = function(key) {
        self.$nextTick(function() {
          self.$refs[key].$el.scrollIntoView({
            behavior: "smooth",
            block: "center"
          });
        });
      };

      if (!this.error) {
        this.$router.push("/kakunin");
      } else {
        this.$nextTick(function() {
          Object.keys(this.check).forEach(function(key) {
            if (this[key]) {
              errorScroll(key);
            }
          }, this.check);
        });
      }
    },

    //住所検索クリックイベント
    addressSearch() {
      var self = this;
      fetch(
        "https://famitei.co.jp/newgrad/api/zip.php?zip=" +
          this.form_data.juusyo.yuubin_num
      )
        .then(function(response) {
          return response.json();
        })
        .then(function(address) {
          self.pref = JSON.stringify(address["pref"]);
          self.city = JSON.stringify(address["city"]);
          self.town = JSON.stringify(address["town"]);
          self.form_data.juusyo.address =
            self.pref.replace(/"/g, "") +
            self.city.replace(/"/g, "") +
            self.town.replace(/"/g, "");
        });
    }
  },
  mounted() {
    //卒業予定年
    var now_year = new Date().getFullYear();
    for (var i = now_year - 2; i <= now_year + 2; i++) {
      this.year.push(i);
    }
  },
  computed: {
    //エラーがあるかないか
    error() {
      if (!this.form_data.mail || !this.form_data.mail.match(/\w@\w/)) {
        return true;
      } else if (
        !this.form_data.tel ||
        !this.form_data.tel.match(/^[0-9-]+$/)
      ) {
        return true;
      } else if (!this.form_data.university) {
        return true;
      } else if (!this.form_data.graduate.year) {
        return true;
      } else if (!this.form_data.graduate.month) {
        return true;
      } else if (!this.form_data.seibetsu) {
        return true;
      } else if (!this.form_data.name.furigana) {
        return true;
      } else if (!this.form_data.name.kanji) {
        return true;
      } else if (!this.form_data.kinmuchi.length) {
        return true;
      } else if (!this.form_data.job) {
        return true;
      }
      return false;
    },

    //フォームトップのエラーメッセージ表示
    ErrorTop() {
      if (Object.values(this.check).length) {
        var a = false;
        Object.values(this.check).forEach(function(i) {
          if (i) {
            a = true;
          }
        });
        return a;
      }
      return false;
    },

    //フォーム監視エラーメッセージ表示
    check() {
      var kekka = {};
      if (!this.click) {
        return kekka;
      }
      kekka.mail = false;
      if (!this.form_data.mail) {
        kekka.mail = "入力してください";
      } else if (!this.form_data.mail.match(/\w@\w/)) {
        kekka.mail = "入力に誤りがあります";
      }

      kekka.tel = false;
      if (!this.form_data.tel) {
        kekka.tel = "入力してください";
      } else if (!this.form_data.tel.match(/^[0-9-]+$/)) {
        kekka.tel = "入力に誤りがあります";
      }

      if (!this.form_data.university) {
        kekka.university = true;
      } else {
        kekka.university = false;
      }

      if (!this.form_data.graduate.month || !this.form_data.graduate.year) {
        kekka.sotsugyou = true;
      } else {
        kekka.sotsugyou = false;
      }

      if (!this.form_data.seibetsu) {
        kekka.seibetsu = true;
      } else {
        kekka.seibetsu = false;
      }

      if (!this.form_data.name.furigana) {
        kekka.furigana = true;
      } else {
        kekka.furigana = false;
      }

      if (!this.form_data.name.kanji) {
        kekka.namae = true;
      } else {
        kekka.namae = false;
      }

      if (!this.form_data.kinmuchi.length) {
        kekka.kinmuchi = true;
      } else {
        kekka.kinmuchi = false;
      }

      if (!this.form_data.job) {
        kekka.job = true;
      } else {
        kekka.job = false;
      }
      return kekka;
    }
  }
};
</script>

<style lang="scss">
.shinsotsu-saiyou {
  letter-spacing: 0.1em;
  line-height: 1.8em;
  text-align: center;
  .s-title {
    background-image: linear-gradient(
      -45deg,
      #ffffff 25%,
      #dadada 25%,
      #dadada 50%,
      #ffffff 50%,
      #ffffff 75%,
      #dadada 75%,
      #dadada
    );
    background-size: 7px 7px;
    padding: 10%;
    &_p {
      border-bottom: 2px solid;
      margin: auto;
      width: 50%;
      span + span {
        margin-left: 0.5em;
      }
    }
  }
  .s-top {
    &_title {
      font-weight: 100;
      letter-spacing: 0.2em;
      margin: 10% 0 5%;
    }
    &_p {
      margin: 0 5%;
    }
    &_ledingCompany {
      font-family: "Charm";
      font-size: 220%;
      font-style: oblique;
      margin: 5% 0 1%;
    }
    img {
      width: 100%;
    }
  }
  .s-box2 {
    p {
      margin: 0 5% 3%;
    }
  }
  .s-saiyou {
    &-flow {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      margin-bottom: 10%;
      &_p {
        border: 1px solid;
        padding: 1% 2%;
        margin: 0 1%;
        background-color: rgb(243, 243, 243);
      }
    }
  }

  .s-entry {
    &-way {
      background-color: #f6f6f6;
      &_tel {
        padding: 1% 0;
        border: solid 1px #b8b8b8;
        &-number {
          color: #3f6eb2;
          .phone-alt {
            margin: 0 2%;
          }
        }
      }
    }

    .errorMessage {
      color: red;
      background-color: #fff3f3;
      border: #f66e6e 1px solid;
      margin: 5% 0;
    }
  }
  //pc style
  @media screen and (min-width: 769px) {
    .s-title {
      &_p {
        font-size: 280%;
      }
    }
    .s-top {
      img {
        margin-top: 15px;
      }
    }
    .s-entry {
      &-way {
        max-width: 60%;
        margin: 0 auto 5%;
        letter-spacing: 0.3em;
        &_tel {
          &-number {
            font-size: 220%;
          }
        }
      }
    }
    .s-box {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      max-width: 1000px;
      margin: 0 auto;
      img {
        width: 60%;
      }
      &-setsumei {
        width: 40%;

        &_title {
          letter-spacing: 0.15em;
          font-family: "Sawarabi Mincho";
        }
        &_p {
          text-indent: 1em;
          padding-left: 1em;
          text-align: left;
        }
      }
    }
    .s-box2 {
      &-img {
        max-width: 600px;
      }
    }
    .smaho {
      display: none;
    }
    //コロナ支援（PC）
    & .corona {
      width: 80%;
      max-width: 650px;
      margin: 0 auto 4%;
      &-text {
        max-width: 80%;
        width: 400px;
        &--p {
          width: 380px;
        }
      }
    }
  }
  & .youtube {
    width: 560px;
    height: 315px;
  }
  //smartphone style
  @media screen and (max-width: 768px) {
    overflow: hidden;
    .s-title {
      &_p {
        font-size: 180%;
        width: 100%;
        padding-bottom: 2%;
      }
    }
    .s-top {
      margin: 15% 0 20%;
      &_title {
        margin: 0 0 10%;
      }
      &_p {
        margin-bottom: 10%;
      }
      img {
        margin-top: 5%;
      }
    }
    .s-box {
      &-img {
        display: none;
      }
      &-setsumei {
        margin: 0 5%;
        &_title {
          margin: 15% 0 10%;
          font-family: "Sawarabi Mincho";
        }
        &_p {
          margin-bottom: 20%;
        }
      }
    }
    .s-box2 {
      margin-bottom: 20%;
      &-img {
        width: 100%;
      }
    }
    .s-saiyou {
      margin-bottom: 10%;
      &-flow {
        margin: 12% 15% 20%;
        &_p {
          width: 100%;
          font-size: 110%;
          padding: 2%;
        }
      }
      .pc {
        display: none;
      }
      &_setsumeikai {
        margin: 0 5%;
      }
    }
    .s-entry {
      &-way {
        width: 100%;
        padding: 2.5% 0;
        margin-bottom: 10%;
        &_tel {
          padding: 5% 2%;
          width: 90%;
          margin: 0 2.5%;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: center;
          &-number {
            font-size: 180%;
            width: 100%;
            padding: 2% 0 5%;
            font-weight: bold;
          }
        }
      }
    }
    & .youtube {
      width: 90%;
      height: 100%;
      margin-bottom: 15%;
    }
    //コロナ支援（スマホ）
    & .corona {
      margin: 0 auto 10%;
      width: 90%;
      max-width: 500px;
      padding: 0 3%;
      &-text {
        max-width: 420px;
      }
    }
  }
  .red {
    color: red;
    font-weight: bold;
  }

  //コロナ学費支援
  & .corona {
    border: 1px solid rgb(175, 175, 175);
    &-text {
      text-align: left;
      margin: 0 auto;
      &--h3 {
        margin: 0;
      }
    }
  }
}
</style>